import { styleBucketOrdering } from '@griffel/core';

const styleBucketOrderingMap = /*#__PURE__*/styleBucketOrdering.reduce((acc, cur, j) => {
  acc[cur] = j;
  return acc;
}, {});
function findInsertionPoint(renderer, styleSheet) {
  var _a;
  let styleSheets = renderer.adoptedStyleSheets;
  const targetOrder = styleBucketOrderingMap[styleSheet.bucketName];
  let comparer = sheet => targetOrder - styleBucketOrderingMap[sheet.bucketName];
  if (styleSheet.bucketName === 'm' && styleSheet.metadata) {
    const mediaElements = renderer.adoptedStyleSheets.filter(styleSheet => styleSheet.bucketName === 'm');
    if (mediaElements.length) {
      styleSheets = mediaElements;
      comparer = sheet => renderer.compareMediaQueries(styleSheet.metadata['m'], sheet.metadata['m']);
    }
  }
  for (let l = styleSheets.length, i = l - 1; i >= 0; i--) {
    const styleElement = styleSheets[i];
    if (comparer(styleElement) > 0) {
      return (_a = styleSheets[i + 1]) !== null && _a !== void 0 ? _a : null;
    }
  }
  if (styleSheets.length > 0) {
    return styleSheets[0];
  }
  return null;
}

export { findInsertionPoint };
//# sourceMappingURL=findInsertionPoint.esm.js.map
